import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-terms',
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}
}
